/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';
import { GetOrganization } from './organization.get';

export const GetOrganizations = {
  id: 'organizations.get',
  tag: 'Organization',
  summary: 'Get organizations',
  description: 'Retrieve all organizations the user has access to',
  method: 'get',
  flags: { isAuthorized: true },
  route: () => '/organization',
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(GetOrganization.response['200'].content['application/json'].schema),
        },
      },
    },
  },
} as const satisfies Endpoint;
